export const LOADING = "LOADING";
export const DELIVERY_LOGIN = "DELIVERY_LOGIN";
export const DELIVERY_PROFILE = "DELIVERY_PROFILE";
export const ASSIGNED_ORDER_LIST = "ASSIGNED_ORDER_LIST";
export const ATTENDANCE_STATUS = "ATTENDANCE_STATUS";